import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { DeleteCommentPayload } from '@web/newsfeed/types/apiTypes';
import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';
import { useArticleCommentsQueryCache } from '@web/newsfeed/Article/ArticleComments/hooks/useArticleCommentsQueryCache';
import { useNewsfeedQueryCacheMutations } from '@web/newsfeed/hooks/useNewsfeedQueryCacheMutations';

export const useDeleteComment = () => {
  const { deleteComment } = useArticleCommentsQueryCache();
  const { onDeleteArticleComment } = useNewsfeedQueryCacheMutations();
  const { newsfeedComments } = useSlingApi();
  const newsfeedBridge = useNewsfeedBridge();

  const mutation = useMutation({
    mutationFn: async ({ pageId, articleId, commentId }: DeleteCommentPayload) => {
      await newsfeedComments.delete(pageId, articleId, commentId);
      return { pageId, articleId, commentId };
    },
    onMutate: (payload) => {
      const revert = deleteComment(payload.articleId, payload.commentId);

      return { revert };
    },
    onError: (err, cachedData, { revert }) => {
      revert();
    },
    onSuccess: (payload) => {
      newsfeedBridge.onDeleteComment(payload);
      onDeleteArticleComment(payload.articleId);
    },
  });

  return mutation;
};
